import React from "react";
import { Col, Row, Alert } from "react-bootstrap";

type AlertProps = {
  variant?: "success" | "danger" | "warning" | "info";
  message: string;
  onClose: () => void;
} & React.HTMLAttributes<HTMLDivElement>;
export default function AlertMessage({
  message,
  variant = "success",
  ...props
}: AlertProps) {
  return !!message ? (
    <div className="m-3">
        <Alert show={!!message} {...{ variant }} {...props} dismissible>
          <div>
            <label>{message}</label>
          </div>
        </Alert>
        </div>
  ) : (
    <div />
  );
}
